const en = {
  lang: 'en_US',
  operator:'Operasi',
  isDel:'Yakin ingin menghapus?',
  success:'Berhasil',
  delSuccess:'Berhasil dihapus!',
  addSuccess:'Berhasil ditambahkan!',
  editSuccess:'Berhasil diedit!',
  error:'Kesalahan',
  query:'Pencarian',
  buxian:'Tidak terbatas',
  home:'Beranda',
  createTime: 'Waktu Pembuatan',
  collectionManagement :'Manajemen Penagihan',
  paymentDays:'Periode Akun',
  bookName:'Nama Periode',
  startNum:'Mulai',
  endNum:'Selesai',
  startLgend:'Selesai harus lebih besar dari mulai',
  addPaymentDays:'Tambah Periode Akun',
  editPaymentDays:'Edit Periode Akun',
  pleaseBookName:'Masukkan nama periode',
  classifyName:'Nama Kategori Penagihan',
  addClassify:'Tambah Kategori Penagihan',
  editClassify:'Edit Kategori Penagihan',
  pleaseClassifyName:'Masukkan nama kategori penagihan',
  classify:'Kategori Penagihan',
  group:'Kelompok Penagihan',
  groupName:'Nama Kelompok',
  zhuguan:'Supervisor',
  pleaseZhuguan:'Pilih supervisor',
  pleaseZhangqi:'Pilih nama periode',
  addgroup:'Tambah Kelompok Penagihan',
  editgroup:'Edit Kelompok Penagihan',
  mubiao:'Target',
  zhuguanname:'Nama Supervisor',
  cxxzcy:'Cari Anggota Kelompok',
  qxzzgmc:'Pilih nama supervisor',
  qxzzqmc:'Pilih nama periode',
  qsrxzmc:'Masukkan nama kelompok',
  mbbnwk:'Target tidak boleh kosong',
  orderManagement:'Manajemen Pesanan Penagihan',
  orderInfo:'Info Penagihan Pesanan',
  phone:'Telepon',
  mchOrderNo: 'Nomor Pesanan',
  email: 'Alamat Email',
  userName: 'Nama',
  cantidad: 'Jumlah yang Harus Dibayar',
  days: 'Jumlah Hari Pinjaman',
  dkje: ' Jumlah Pinjaman',
  fkje: 'Jumlah Pencairan',
  fwf : 'Biaya Layanan',
  lx: 'Bunga',
  sje: 'Jumlah Diterima',
  fksj : 'Waktu Pencairan',
  lastTime: ' Waktu Pembayaran Terakhir',
  skzh : 'Akun Penerima',
  amount: 'Jumlah',
  plannedRepaymentAmount: 'Jumlah Pembayaran',
  channel: 'Saluran',
  overdueDay: 'Hari Keterlambatan',
  expireTime: 'Tanggal Jatuh Tempo',
  exclusiveLinks:'Tautan Pembayaran',
  stats: 'Status Pesanan',
  guanxi: 'Hubungan',
  qxzguanxi: 'Pilih hubungan',
  name: 'Nama',
  jjlxr: 'Kontak Darurat',
  thcs: 'Jumlah Panggilan',
  thsj: 'Waktu Panggilan',
  csy: 'Kolektor',
  addInfo: 'Tambahkan Catatan',
  editInfo: 'Edit Catatan',
  telTime: 'Tanggal Panggilan',
  rlTime: 'Tanggal Janji',
  fl: 'Kategori',
  yg: 'Karyawan',
  beizhu: 'Catatan',
  xzTime: 'Pilih Tanggal',
  qxzflmc: 'Pilih nama kategori',
  yqddgl: 'Manajemen Pesanan Terlambat',
  time: 'Rentang Waktu',
  fp: 'Distribusi',
  ckrq: 'Tanggal Setoran',
  qxzcsymc: 'Pilih nama kolektor',
  qgxfpdd: 'Pilih pesanan yang akan didistribusikan!',
  wbddgl: 'Manajemen Pesanan Eksternal',
  cpm:'Nama Produk',
  value1: 'Data Aplikasi Hari Ini',
  value2: 'Tanggal',
  value3: 'Pengguna Baru',
  value4: 'Jumlah Pendaftaran',
  value5: 'Jumlah Aplikasi',
  value6: 'Jumlah Ditolak',
  value7: 'Jumlah Disetujui',
  value8: 'Tingkat Persetujuan',
  value9: 'Pencairan Berhasil Hari Ini',
  value10: 'Pencairan Gagal Hari Ini',
  value11: 'Pencairan Proses Hari Ini',
  value12: 'Total Pencairan Berhasil',
  value13: 'Total Pencairan Gagal',
  value14: 'Total Pencairan Proses',
  value15: 'Total Pesanan',
  value16: 'Pesanan Pembayaran Berhasil',
  value17: 'Tingkat Keterlambatan',
  value18: 'Jumlah Pesanan',
  value19: 'Total Pesanan Belum Jatuh Tempo',
  value20: 'Total Jumlah Pesanan Belum Jatuh Tempo',
  value21: 'Jumlah Proses Verifikasi Hari Ini',
  value22: 'Total Proses Verifikasi',
  dlm: 'Nama Login',
  mm: 'Kata Sandi',
  yzm: 'Kode Verifikasi',
  dl: 'Login',
  yhgl: 'Manajemen Pengguna',
  gjz: 'Kata Kunci',
  qddh: 'Saluran/Telepon',
  yhzt: 'Status Pengguna',
  qxzyhzt: 'Pilih status pengguna',
  ssje: 'Jumlah Diterima',
  drz : 'Menunggu Verifikasi',
  rzz : 'Sedang Diverifikasi',
  dqy : 'Menunggu Penandatanganan',
  shz : 'Sedang Diproses',
  shjj : 'Ditolak',
  fksb : 'Pencairan Gagal',
  jj : 'Lunas',
  wdq : 'Belum Jatuh Tempo',
  dqr : 'Tanggal Jatuh Tempo',
  yq : 'Terlambat',
  yfk : 'Telah Dicairkan',
  yhk : 'Telah Dibayar',
  whk : 'Belum Dibayar',
  ddbj : 'Pesanan Ditolak',
  fqwsx : 'Cicilan Tidak Aktif',
  channel : 'Saluran',
  status : 'Status',
  zhdlsh: 'Waktu Login Terakhir',
  rzxx: 'Info Verifikasi',
  yhrzxx: 'Info Verifikasi Pengguna',
  yhdh:'Telepon Pengguna',
  birthday:'Ulang Tahun',
  addressAll:'Alamat',
  gender:'Jenis Kelamin',
  fatherLastName:'Nama Belakang Ayah',
  motherLastName:'Nama Belakang Ibu',
  postalCode:'Kode Pos',
  fullName:'Nama Lengkap',
  idNumber:'Nomor KTP',
  district:'Wilayah',
  educationName:'Tingkat Pendidikan',
  employmentName:'Status Pekerjaan',
  comoanyName:'Nama Perusahaan',
  comoanyPhone:'Telepon Perusahaan',
  workingYearName:'Lama Bekerja',
  monthlySalaryName:'Penghasilan Bulanan',
  workingDaysName:'Hari Gajian',
  idCardPositive:'Foto KTP Depan',
  idCardReverse:'Foto KTP Belakang',
  faceUrl:'Wajah',
  jzz:'Sedang Memuat',
  zqyq:'Manajemen Perpanjangan/Keterlambatan',
  type:'Jenis',
  qxztype:'Pilih jenis',
  zq:'Perpanjangan',
  yq:'Terlambat',
  day:'Hari',
  sourceMoney :'Jumlah Sumber',
  yhhkgl: 'Manajemen Pembayaran Pengguna',
  hbj :'Bayar Pokok',
  hzq : 'Bayar Perpanjangan',
  hwbdd : 'Bayar Pesanan Eksternal',
  hfq : 'Bayar Cicilan',
  orderNum : 'Akun Pembayaran',
  typeName: 'Metode Pembayaran',
  iden: 'Jenis Pembayaran',
  ddgl: 'Manajemen Pesanan',
  orderNo : 'Nomor Transaksi',
  xtgl: 'Manajemen Sistem',
  ncdh : 'Nama Panggilan/Telepon',
  nc:'Nama Panggilan',
  role: 'Peran',
  qxzrole : 'Pilih peran',
  adduser: 'Tambah Pengguna',
  edituser :'Edit Pengguna',
  gsxz : 'Kelompok Asal',
  isczmm : 'Yakin reset kata sandi?',
  jsdl : 'Buka Kunci Login',
  dlzh : 'Akun Login',
  qxzfz : 'Pilih grup',
  jihuo: 'Aktif',
  suoding: 'Kunci',
  nan :'Pria',
  nv: 'Wanita',
  qsryhm: ' Masukkan nama pengguna',
  qsryhnc : 'Masukkan nama panggilan',
  qsryxdz : 'Masukkan alamat email',
  qsrzqyxdz : 'Masukkan alamat email yang valid',
  qsrsjh: ' Masukkan nomor telepon',
  jscg : 'Berhasil membuka kunci!',
  czcg1 : 'Reset berhasil!',
  czsb : 'Reset gagal!',
  shibai: 'Gagal',
  czcg : 'Operasi berhasil!',
  grzx : 'Profil',
  xgmm : 'Ubah Kata Sandi',
  lmm : 'Kata Sandi Lama',
  xmm : 'Kata Sandi Baru',
  qrxmm : 'Konfirmasi Kata Sandi Baru',
  baoc : 'Simpan',
  qsrlmm : 'Masukkan kata sandi lama!',
  qsrxmm : 'Masukkan kata sandi baru!',
  llmmbyz : 'Kata sandi tidak cocok!',
  xgcg : 'Berhasil diubah!',
  jegl : 'Manajemen Peran',
  addrole : 'Tambah Peran',
  editrole : 'Edit Peran',
  rolename : 'Nama Peran',
  roleLe : 'Tingkat Peran',
  data : 'Cakupan Data',
  quanbu : 'Semua',
  benji : 'Lokal',
  zidy : 'Kustom',
  rolems : 'Deskripsi Peran',
  tianj : 'Tambah',
  qxzsjfw : 'Pilih cakupan data',
  qcxxzsjfw : 'Pilih ulang cakupan data',
  qxz : 'Pilih',
  xiugai : 'Edit',
  fpcd : 'Distribusi Menu',
  bccdcg : 'Berhasil menyimpan menu!',
  cpgl:'Manajemen Produk',
  addcp :'Tambah Produk',
  editcp : 'Edit Produk',
  cpmc:'Nama Produk',
  dkqx:'Jangka Pinjaman (hari)',
  zqfl:'Biaya Perpanjangan',
  fxfl:'Biaya Denda',
  flsqfs:'Metode Pembayaran Biaya',
  fk1:'Potong biaya layanan dan bunga saat pencairan',
  fk2:'Potong biaya layanan saat pencairan, bunga dibayar saat jatuh tempo',
  fk3:'Bayar biaya layanan dan bunga saat jatuh tempo',
  sytj:'Syarat Penggunaan/Jumlah',
  jxks:'Mulai Perhitungan Bunga',
  fkdr:'Hari pencairan (N-1)',
  fkcr:'Hari setelah pencairan (N)',
  tqhk:'Metode Perhitungan Bunga Pelunasan Awal',
  qxjx:'Bunga Periode Penuh',
  sjsyjz:'Bunga Penggunaan Aktual',
  qiyong :'Aktif',
  jinyong:'Nonaktif',
  qq1:'Pilih metode pembayaran biaya',
  qq2:'Pilih mulai perhitungan bunga',
  qq3:'Pilih metode perhitungan bunga pembayaran',
  qxgl:'Manajemen Izin',
  addzcd:' Tambah Menu Utama',
  cdbt:'Judul Menu',
  tup:'Ikon',
  qxlj:'Path Izin',
  qxbs:'Identifikasi Izin',
  paix:'Urutan',
  addzjd:'Tambah Submenu',
  addcd :'Tambah Menu',
  cdmc:'Nama Menu',
  qxurl:'URL Izin',
  editcd:'Edit Menu',
  zhucd:'Menu Utama',
  zcd:'Submenu',
  gongn:'Fungsi',
  sysparam:'Konfigurasi Parameter Sistem',
  paramName:'Nama Parameter',
  paramValue:'Nilai Parameter',
  editSys:'Edit Parameter Sistem',
  edgl:'Manajemen Limit',
  tegz:'Aturan Peningkatan Limit',
  jegz:'Aturan Penurunan Limit',
  added:'Tambah Limit',
  edited:'Edit Limit',
  jkcs:'Jumlah Pinjaman',
  yqcstype:'Jenis Jumlah Keterlambatan',
  yqcs:'Jumlah Keterlambatan',
  zhycjktype:'Jenis Hari Keterlambatan Pinjaman Terakhir',
  zhycjkts:'Hari Keterlambatan Pinjaman Terakhir',
  dzed:'Sesuaikan Limit',
  qxzyqlx:'Pilih jenis keterlambatan',
  qxzyqcslx:'Pilih jenis jumlah keterlambatan',
  qxzzhycjktslx:'Pilih jenis hari keterlambatan pinjaman terakhir',
  v1:'Sama dengan',
  v2:'Tidak sama dengan',
  v3:'Lebih besar',
  v4:'Lebih besar atau sama',
  v5:'Lebih kecil',
  v6:'Lebih kecil atau sama',
  v7:'Antara...',
  v8:'Tidak antara...',
  v9:'Termasuk dalam...',
  v10:'Tidak termasuk dalam...',
  loggl:'Manajemen Log',
  yonghum:'Nama Pengguna',
  jieguo:'Hasil',
  liulq:'Browser',
  shic:'Durasi',
  wdcsdd:'Pesanan Penagihan Saya',
  zczds:'Total Pesanan dalam Penagihan',
  jrchds:'Pesanan Ditagih Hari Ini',
  jrchl:'Rasio Penagihan Hari Ini',
  zcje:'Jumlah dalam Penagihan',
  chje:'Jumlah Ditagih',
  z:'hingga',
  kssj:'Waktu Mulai',
  jssj:'Waktu Selesai',
  tjcsjl:'Tambahkan Catatan Penagihan',
  jbxx:'Informasi Dasar',
  ddxq:'Detail Pesanan',
  gzxx:'Informasi Pekerjaan',
  lxr1xm:'Kontak 1: Nama',
  lxr1gx:'Kontak 1: Hubungan',
  lxr1dh:'Kontak 1: Telepon',
  lxr2xm:'Kontak 2: Nama',
  lxr2dh:'Kontak 2: Telepon',
  lxr2gx:'Kontak 2: Hubungan',
  lxr3xm:'Kontak 3: Nama',
  lxr3dh:'Kontak 3: Telepon',
  lxr3gx:'Kontak 3: Hubungan',
  lxr4xm:'Kontak 4: Nama',
  lxr4dh:'Kontak 4: Telepon',
  lxr4gx:'Kontak 4: Hubungan',
  sfxx:'Informasi Identitas',
  txl:'Buku Alamat',
  gzjl:'Catatan Pelacakan',
  csjl:'Catatan Penagihan',
  cjrq:'Tanggal Pembuatan',
  qxzyggx:'Pilih hubungan',
  qsrxm:'Masukkan nama',
  qsrdh:'Masukkan telepon',
  qxzrq:'Pilih tanggal',
  qsrbz:'Masukkan catatan',
  qxzdd:'Pilih pesanan',
  zclstj:'Statistik Riwayat Penagihan',
  chjel:'Rasio Jumlah Ditagih',
  cscgjl:'Catatan Penagihan Berhasil',
  cscgyqjl:'Catatan Keterlambatan Penagihan Berhasil',
  zctj:'Statistik Penagihan',
  home1:'Pengguna Repeat',
  home2:'Data Pencairan',
  home3:'Data Hari Ini',
  home4:'Data Historis',
  home5:'Data Pembayaran',
  home6:'Data Pesanan Jatuh Tempo Hari Ini',
  home7:'Data Pengguna Baru Pesanan Jatuh Tempo Hari Ini',
  home8:'Data Pengguna Repeat Pesanan Jatuh Tempo Hari Ini',
  home9:'Data Pinjaman Aktif',
  login1:'Anda mengganti lingkungan platform, harap logout dan login kembali',
  login2:'Ganti Bahasa',
  login3:'Konfirmasi',
  login4:'Logout berhasil!',

  dc1:'Ikhtisar Data Harian',
  dc2:'Jumlah Distribusi Hari Ini: ',
  dc3:'Rasio Pemulihan Hari Ini: ',
  dc4:'Rasio Pemulihan Distribusi Baru Hari Ini: ',
  dc5:'Rasio Pemulihan Selesai Kemarin: ',
  dc6:'Rasio Pemulihan Bulanan: ',
  dc7:'Jumlah Pembayaran Selesai Hari Ini: ',
  dc8:'Jumlah Distribusi Baru Kemarin: ',
  dc9:'Rasio Pemulihan Distribusi Baru Bulanan: ',
  dc10:'Sedang Ditagih: ',
  dc11:'Jumlah Pembayaran Kemarin: ',
  dc12:'Nama Karyawan',
  dc22:'Jumlah Distribusi Hari Ini',
  dc23:'Jumlah Distribusi Hari Ini',
  dc24:'Jumlah Pemulihan Hari Ini',
  dc25:'Rasio Pemulihan Jumlah Distribusi Hari Ini',
  dc13:'Sisa yang Belum Diproses',
  dc14:'Pemulihan Selesai Hari Ini',
  dc15:'Rasio Pemulihan Distribusi Baru Hari Ini',
  dc16:'Sisa pembayaran pada hari itu',
  dc17:'Rasio Pemulihan Bulanan',
  dc18:'Rasio Pemulihan Distribusi Baru Bulanan',
  dc19:'Jumlah Distribusi Baru Kemarin',
  dc20:'Jumlah Pembayaran Kemarin',
  dc21:'Rasio Pemulihan Selesai Kemarin',

  der1:'Konfigurasi Periode',
  der2:'Pengurangan Penagihan',
  der3:'Tambah Pengurangan',
  der4:'Edit Pengurangan',
  der5:'Persentase Pengurangan Maksimum per Pesanan',
  der6:'Jumlah Maksimum Pengurangan per Bulan',
  der7:'Perkiraan 7 Hari ke Depan',
  der8:'Perkiraan Kasus',

  call0:'Laporan Real-time Penagihan',
  call1:'Ditagih',
  call2:'Tanggal Masuk Penagihan: ',
  call3:'Total',
  call4:'Jumlah Masuk Penagihan Hari Ini: ',
  call5:'Pelanggan Baru Masuk Penagihan: ',
  call6:'Pelanggan Lama Masuk Penagihan: ',
  call7:'Jumlah Penagihan Pelanggan Baru Saat Ini: ',
  call8:'Jumlah Penagihan Pelanggan Lama Saat Ini: ',
  call9:'Rasio Penagihan Pelanggan Baru Saat Ini: ',
  call10:'Rasio Penagihan Pelanggan Lama Saat Ini: ',
  call11:'Total Rasio Penagihan Saat Ini: ',

  loan1:'Halaman Data Pasca-Pencairan',
  loan2:'Tanggal Pencairan',
  loan3:'Jumlah Kasus Jatuh Tempo',
  loan7:'Kasus Masuk Penagihan',
  loan8:'Jumlah Perpanjangan',

  oter:'Jumlah Pembayaran',
  oter1:'Daftar Pesanan Gagal Pencairan',
  oter2:'Pencairan Ulang',
  oter3:'Pencairan Berhasil',

  txl1:'Keluarga',
  txl2:'Umum',

  loan4:'Pinjaman Pertama',
  loan5:'Pinjaman Ulang',

  qux:'Batal',
  cffkqr:'Pencairan ulang, konfirmasi informasi',
  fkje1:'Jumlah Pencairan: ',
  orderNo1:'Nomor Pesanan: ',
  phone1:'Telepon: ',
  fkz1:'Sedang Mencairkan...',

  cd1:'Lihat Detail',
  cd2:'Detail Statistik Riwayat Penagihan',

  callnum:'Jumlah Penagihan',
  pingt:'Platform',
  iscancelar:'Apakah ingin melunasi pesanan ini?',

  p1:'Notifikasi',
  p2:'Tambah Notifikasi',
  p3:'Konten',
  p4:'Penerima',
  p5:'Saluran',
  p6:'SMS',
  p7:'APP',
  p8:'Email',
  p9:'Platform',
  p10:'ID Template Pesan: ',
  p11:'Konten: ',
  p12:'Saluran: ',
  p13:'Platform: ',
  p14:'Penerima: ',
  p15:'Template Pesan',
  p16:'Tambah Template Pesan',
  p17:'ID Template',
  p18:'Jenis',
  p19:'Konten Pesan',
  p20:'Waktu',
  p21:'Edit Template Pesan',
  p22:'Jenis: ',
  p23:'Waktu: ',
  p24:'Konten Pesan: ',

  o1:'Verifikasi Pesanan',
  o2:'Catatan Verifikasi',
  o3:'Info Verifikasi: ',
  o4:'Verifikasi',
  o5:'Pencairan',
  o6:'Tolak',
  o7:'Verifikasi Info Pengguna',
  o8:'Verifikasi',

  c1:'Info Palsu: ',
  c2:'Info Kedaluwarsa: ',
  c3:'Info Risiko Lain: ',
  c4:'Konfirmasi Sambungan Telepon: ',
  c5:'Konfirmasi WA: ',
  c6:'Kontak Darurat 1 Kenal Pemohon: ',
  c7:'Balasan WA Kontak Darurat 1: ',
  c8:'Kontak Darurat 2 Kenal Pemohon: ',
  c9:'Balasan WA Kontak Darurat 2: ',
  c10:'Rekomendasi Verifikasi: ',

  c11:'Akun Pembayaran',
  c12:'Lihat Tautan Pembayaran',
  c13:'Lihat Akun Pembayaran',

  c14:'Pencairan',
  c15:'Profil Pengguna',
  c16:'Yakin tambahkan ke daftar hitam?',

  c17:'Jumlah Jatuh Tempo',
  c18:'Jumlah Masuk Penagihan',
  c19:'Jumlah Pembayaran',
  c20:'Jumlah Perpanjangan',

  c21:'Negara',
  c22:'NX Nomor Telepon',
  c23:'IN Nomor Telepon',
  c24:'Call platform',
  c25:'KMI Nomor Telepon',
  c26:'94AI Nomor Telepon',

  w00:'Manajemen Telepon',
  w01:'Akun Karyawan',
  w02:'ID Suara',
  w03:'Nama Grup SIP',
  w04:'Nama Telepon',
  w05:'Nomor Tujuan',
  w06:'Nomor Tampilan',
  w07:'Operator Lokal',
  w08:'Jenis',
  w09:'Waktu Panggilan',
  w10:'Waktu Pengajuan',
  w11:'Waktu Panggilan',
  w12:'Waktu Berdering',
  w13:'Waktu Terjawab',
  w14:'Waktu Menutup',
  w15:'Durasi Panggilan (detik)',
  w16:'Durasi Tagihan (detik)',
  w17:'Kode Status',
  w18:'Deskripsi Status',
  w19:'Jumlah Tagihan (€)',
  w20:'Siklus Tagihan',
  w21:'Tarif (€)',
  w22:'ID Rekaman',

  dd1:'Rasio Cakupan',
  dd2:'Jumlah Panggilan (Total)',
  dd3:'Jumlah Panggilan (Pribadi)',
  dd4:'Jumlah Panggilan (Kontak)',
  dd5:'Rasio Sambungan',
  dd6:'Durasi Panggilan',

  fqcs:'Jumlah Cicilan',

  ag1:'Tanggal Jatuh Tempo',
  ag2:'Jumlah Hari Cicilan',
  ag3:'Jumlah Cicilan',
  ag4:'Bunga Cicilan',
  ag5:'Biaya Layanan Cicilan',
  ag6:'Cicilan Manual',
  ag7:'Pengurangan Jumlah',
  ag8:'Jumlah: ',
  ag9:'Apakah cicilan aktif?',
  ag10:'Pencarian Bukti',

  releOrder:'Pesanan Terkait',
  linkOpen:'Buka Semua Tautan Profil',
  upProductName:'Nama Produk Utama',
  ssociatedTel:'Info Telepon Terkait',

  tel1: 'Manajemen Penjualan Telepon',
  tel2: 'Tim Penjualan Telepon',
  tel3: 'Tambahkan Tim Penjualan Telepon',
  tel4: 'Edit Tim Penjualan Telepon',
  tel5: 'Catatan Pelacakan',
  tel6: 'Telepon',
  tel7: 'Waktu',
  tel8: 'Status',
  tel9: 'Saluran',
  tel10: 'Daftar Penjualan Telepon',
  tel11: 'Belum Ditelepon',
  tel12: 'Sudah Ditelepon',
  tel13: 'Impor',
  tel14: 'Unduh Template',
  tel15: 'Apakah Sudah Ditelepon?',
  tel16: 'Silakan Pilih Saluran',
  tel17: 'Silakan Pilih File yang Diunggah',
  tel18: 'Seret File ke Sini, atau',
  tel19: 'Klik untuk Mengunggah',
  tel20: 'Hanya Bisa Mengunggah File Excel',
  tel21: 'Laporan Kinerja Agen Penjualan Telepon',
  tel22: 'Statistik Beban Kerja Penjualan Telepon',
  tel23: 'Nama Penjualan Telepon',
  tel24: 'Jenis Kelompok Pelanggan',
  tel25: 'Jumlah Pembagian Order',
  tel26: 'Jumlah Panggilan Keluar',
  tel27: 'Rasio Panggilan Keluar',
  tel28: 'Total Panggilan Keluar',
  tel29: 'Rata-rata Panggilan per Kasus',
  tel30: 'Jumlah Panggilan Terhubung',
  tel31: 'Rasio Panggilan Terhubung',
  tel32: 'Jumlah Aplikasi',
  tel33: 'Rasio Aplikasi',
  tel34: 'Jumlah WA Terkirim',
  tel35:'Mendorong tangan',
  tel36:'Mendorong saluran：',
  tel37:'SMS',
  tel38:'Google',
  tel39:'Platform push：',
  tel40:'Mulai mendorong',
  tel41:'Statistik laba',
  tel42:'Id penilaian informasi',
  tel43:'Keseluruhan data setelah pinjaman (order)',
  tel44:'Keseluruhan data setelah pinjaman (jumlah)',

  tel45: 'Jenis Alokasi',
  tel46: 'Acak',
  tel47: 'Tetap',

  tel48: 'Jumlah Pendaftaran',
  tel49: 'Jumlah Aplikasi',
  tel50: 'Jumlah Disetujui',
  tel51: 'Jumlah Pencairan Berhasil',
  tel52: 'Jumlah Pencairan Gagal',
  tel53: 'Jumlah Pencairan Dana',
  tel54: 'Jumlah Pembayaran Kembali',
  tel55: 'Tingkat Pembayaran Kembali',
  tel56: 'Jumlah Pinjaman Pertama',
  tel57: 'Jumlah Pinjaman Berulang',
  tel58: 'Tingkat Pembayaran Pinjaman Pertama',
  tel59: 'Tingkat Pembayaran Pinjaman Berulang',

  tel60: 'Penerima',
  tel61: 'Sumber Daftar',
  tel62: 'Belum Dialokasikan',
  tel63: 'Sudah Dialokasikan',
  tel64: 'Sudah Diaktifkan',
  tel65: 'Belum Diaktifkan',
  tel66: 'Telemarketer:',
  tel67: 'Silakan centang nomor yang perlu dialokasikan',
  tel68: 'Silakan centang telemarketer yang akan dialokasikan',
  tel69: 'Daftar Telemarketing Sukses Saya',
  tel70: 'Daftar Telemarketing Saya',
  tel71: 'Total Panggilan Ulang',
  tel72: 'Jumlah Aktivasi Hari Ini',
  tel73: 'Tingkat Aktivasi Hari Ini',
  tel74: 'Nama Karyawan',
  tel75: 'Jumlah Hari Tinggal',
  tel76: 'Tambahkan Catatan Telemarketing',

  tel77: 'Konfigurasi Alokasi',
  tel78: 'Jumlah Alokasi Maksimum Harian',
  tel79: 'Jumlah Hari Tinggal',
  tel80: 'Tambahkan Konfigurasi Alokasi',
  tel81: 'Edit Konfigurasi Alokasi',
  tel82: 'Tim Telemarketing',
  tel83: 'Apakah Anda yakin ingin menghapus?',
  tel84:'Data diekspor',

  tel85: 'Status Panggilan',  
  tel86: 'Hapus',            
  tel87: 'Waktu tidak boleh kosong', 
  tel88: 'Waktu Aktivasi',   
  tel89: 'Nama Pengguna',   
  tel90: 'Email Pengguna',   
  tel91: 'Apakah Mendaftar', 
  tel92: 'Tidak',             
  tel93: 'Ya',

  nxc1:'Arah Panggilan',
  nxc2:'Alasan Pemutusan Panggilan',
  nxc3:'Waktu Sambungan Panggilan',
  nxc4:'Waktu Mulai Percakapan',
  nxc5:'Waktu Selesai Percakapan',
  nxc6:'Durasi Percakapan',

  re1:'Laporan',
  re2:'Transaksi Registrasi',
  re3:'Tanggal Registrasi',
  re4:'Jumlah Registrasi',
  re5:'Jumlah Pinjaman',
  re6:'Jumlah Klik Aplikasi',
  re7:'Jumlah Percobaan Registrasi',
  re8:'Rasio Registrasi ke Pinjaman',
  re9:'Rasio Registrasi ke Klik Aplikasi',
  re10:'Tingkat Kelulusan Pemeriksaan Otomatis',
  re11:'Rasio Klik Aplikasi ke Pemeriksaan',
  re12:'Rasio Masuk ke Pemeriksaan Otomatis Selesai',
  re13:'Rasio Kelulusan Otomatis ke Pemeriksaan Manual',
  re14:'Tingkat Kelulusan Pemeriksaan Manual',

  re16:'Lihat rekamannya.',

  re17:'Jumlah Perpanjangan',     // 展期数
  re18:'Tingkat Perpanjangan',   // 展期率
  re19:'Tingkat Cakupan',        // 覆盖率
  re20:'Jumlah Panggilan',       // 拨号总数
  re21:'Tingkat Koneksi',        // 接通率
  re22:'Durasi Panggilan',       // 通话时长

  re23:'Label',                  // 标签
  re24:'Pesan WhatsApp sudah dibaca tetapi tidak dibalas',   // whatsapp信息已读不回
  re25:'Pesan WhatsApp sudah dibaca dan dibalas',            // whatsapp信息已读且回复
  re26:'Panggilan terhubung - Sales',                        // 拨打电话客户接通-电销员
  re27:'Panggilan terhubung - Sistem',                       // 拨打电话客户接通-系统

  re28:'Jumlah Aktivasi',        // 总激活数
  re29:'Tingkat Aktivasi',       // 激活率
  re30:'Jumlah Aplikasi',        // 申请数
  re31:'Tingkat Aplikasi',       // 申请率

  re32:'Aktivitas Pengguna',     // 用户活跃度

}
export default en;